import { graphql } from "gatsby"
import React from "react"

import NumericList from "@molecules/NumericList/NumericList"

const NumericListBlock = ({ blockDataNumericList }) => {
  const { heading, list, background } = blockDataNumericList || {}

  return (
    <NumericList
      heading={heading}
      list={list?.split("\r\n").filter(Boolean)}
      background={background}
    />
  )
}

export const query = graphql`
  fragment NumericList on WpBlockAcfNumericList {
    __typename
    blockDataNumericList {
      background
      heading
      list
    }
  }
`

export default NumericListBlock
